import _ from 'lodash';
import { SLTXFormatRootFile } from './sltx';
import { SLTXVersionConverterV1ToV2 } from './sltxVersionConversionV1ToV2';
import { SLTXFormatRootFileV1 } from './sltx_v1';

export interface SLTXFormatRootFileVersion {
  version: number | undefined;
}

export function getSLTXFileContentsInLatestVersion(
  fileContents : any,
) : SLTXFormatRootFile | undefined {

  const fileVersion : SLTXFormatRootFileVersion = fileContents as SLTXFormatRootFileVersion;

  let fileVersionNr = 1;
  if (fileVersion.version !== undefined) {
    fileVersionNr = Number.parseInt(`${fileVersion.version}`, 10);
  }

  let catalogObjectExtraInfo : SLTXFormatRootFile | undefined;

  if (fileVersionNr === 1) {
    catalogObjectExtraInfo = SLTXVersionConverterV1ToV2.convertFileFormatToV2(
      fileContents as SLTXFormatRootFileV1,
    );
  }

  // This is the latest version until now
  if (fileVersionNr === 2) {
    catalogObjectExtraInfo = fileContents as SLTXFormatRootFile;

    // Clean groups that have no options
    if (catalogObjectExtraInfo.groups) {

      const newGroups = catalogObjectExtraInfo.groups.map((group) => {

        const newGroup = _.cloneDeep(group);
        const newOptionsFolders = group.optionsFolders.filter((optionFolder) => {
          return optionFolder.options.length > 0;
        });
        newGroup.optionsFolders = newOptionsFolders;
        return newGroup;
      });

      catalogObjectExtraInfo.groups = newGroups;
    }
  }

  return catalogObjectExtraInfo;
}
